import React from "react";
import type { SeasonPoints } from "../api/types";
import { ordinal } from "../utils/seasonText";

/** What every race pays, from the season's own points config. */
const PointsTable: React.FC<{ points: SeasonPoints }> = ({ points }) => (
  <ul className="gm-points" aria-label="Points per race">
    {points.place.map((pts, i) => (
      <li key={i}>
        <span>{i === 0 ? "1st in the race" : `${ordinal(i + 1)}`}</span>
        <span className="gm-points__pts">{pts}</span>
      </li>
    ))}
    <li>
      <span>Raced at all (on top of a place)</span>
      <span className="gm-points__pts">{points.raced}</span>
    </li>
    <li>
      <span>Won the AOTD guessing</span>
      <span className="gm-points__pts">{points.guessWin}</span>
    </li>
  </ul>
);

export default PointsTable;
